import { persistedReducer as adminInvoices } from "./Containers/AdminInvoicesPage/redux/adminInvoices.slice"
import { persistedReducer as adminUsers } from "./Containers/AdminUsersPage/redux/adminUsers.slice"
import { persistedReducer as alerts } from "./Containers/AlertsPage/redux/alerts.slice"
import { reducer as balance } from "./Containers/Balance/reducer"
import { persistedReducer as businessAccounts } from "./Containers/BusinessAccountsPage/redux/businessAccounts.slice"
import { reducer as businessDetails } from "./Containers/BusinessDetailsBlock/reducer"
import { persistedReducer as credits } from "./Containers/CreditsPage/reducer"
import { persistedReducer as dashboard } from "./Containers/DashboardPage/redux/dashboard.slice"
import { persistedReducer as deflectAnalytics } from "./Containers/DeflectAnalyticsPage/redux/deflectAnalytics.slice"
import { reducer as globalFilters } from "./Containers/GlobalFilters/reducer"
import { persistedReducer as health } from "./Containers/Health/reducer"
import { persistedReducer as home } from "./Containers/HomePage/redux/home.slice"
import { persistedReducer as invoices } from "./Containers/InvoiceHistoryBlock/redux/invoices.slice"
import { persistedReducer as auth } from "./Containers/LoginPage/redux/auth.slice"
import { reducer as marketing } from "./Containers/MarketingPage/reducer"
import { reducer as paymentMatching } from "./Containers/PaymentMatchingPage/reducer"
import { reducer as perksAdmin } from "./Containers/PerksAdminPage/reducer"
import { reducer as perks } from "./Containers/PerksPage/reducer"
import { reducer as publicApi } from "./Containers/PersonalSettings/PublicAPI/reducer"
import pricing from "./Containers/PricingPage/redux/pricing.slice"
import { persistedReducer as receiptBusiness } from "./Containers/ReceiptPage/ConfigureBusinessPage/redux/business.slice"
import { persistedReducer as receiptConfigure } from "./Containers/ReceiptPage/ConfigureProfilePage/redux/configure.slice"
import { persistedReducer as receipt } from "./Containers/ReceiptPage/redux/receipt.slice"
import { reducer as referrals } from "./Containers/Referrals/reducer"
import { reducer as requests } from "./Containers/RequestsPage/reducer"
// import { reducer as requestsDescriptors } from './Containers/RequestsPage/RequestsDescriptors/reducer';
import { persistedReducer as requestsAutoRefund } from "./Containers/RequestsPage/RequestsAutoRefund/redux/requestsAutoRefund.slice"
import { reducer as requestsEnrollments } from "./Containers/RequestsPage/RequestsEnrollments/redux/requestsEnrollments.slice"
import { persistedReducer as requestsGifts } from "./Containers/RequestsPage/RequestsGifts/redux/requestsGifts.slice"
import { persistedReducer as requestsIntegrations } from "./Containers/RequestsPage/RequestsIntegrations/redux/requestsIntegrations.slice"
import { reducer as requestsReceipts } from "./Containers/RequestsPage/RequestsReceipts/redux/requestsReceipts.slice"
import { persistedReducer as requestsVerifiInform } from "./Containers/RequestsPage/RequestsVerifiInform/redux/requestsVerifiInform.slice"
import { persistedReducer as requestsWithdrawal } from "./Containers/RequestsPage/RequestsWithdrawal/redux/requestsWithdrawal.slice"
import { persistedReducer as setting } from "./Containers/Setting/redux/setting.slice"
//import { reducer as breadCrumbs } from './Containers/Breadcrumbs/actions';
import { reducer as shopifyMove } from "./Containers/ShopifyMove/redux/shopifyMove.slice"
import { persistedReducer as user } from "./Containers/User/redux/user.slice"
import { persistedReducer as users } from "./Containers/UsersPage/redux/users.slice"
import { persistedReducer as nav } from "./Redux/nav/nav.slice"
import { persistedReducer as errors } from "./Redux/redux/errors.slice"

export const reducers = {
  auth,
  nav,
  errors,
  user,
  dashboard,
  alerts,
  home,
  //breadcrumbs: breadCrumbs,
  setting,
  shopifyMove,
  users,
  businessAccounts,
  adminUsers,
  requestsEnrollments,
  // requestsDescriptors,
  requestsAutoRefund,
  requestsIntegrations,
  requestsGifts,
  requestsWithdrawal,
  requestsReceipts,
  requestsVerifiInform,
  receipt,
  receiptConfigure,
  receiptBusiness,
  deflectAnalytics,
  adminInvoices,
  pricing,
  invoices,
  globalFilters,
  credits,
  balance,
  marketing,
  requests,
  referrals,
  businessDetails,
  publicApi,
  health,
  perks,
  paymentMatching,
  perksAdmin
}

export default reducers
